import TuneIcon from "@mui/icons-material/Tune";

const DashboardTable = ({ allCompanies }) => {
  return (
    <div className="Dashboard_Table">
      <div className="Top_Box">
        <h3>Companies</h3>
        {/* <div className="Btn">
          <h4>Filter & Short</h4>
          <svg>
            <TuneIcon />
          </svg>
        </div> */}
      </div>
      <table>
        <thead>
          <th>Name</th>
          <th>Email</th>
          <th>Location</th>
        </thead>
        <tbody>
          {
            allCompanies?.map((company) => (
              <tr key={company?.id} >
                <td><div className="Box">{company?.name}</div> </td>
                <td><div className="Box">{company?.email}</div> </td>
                <td><div className="Box">{company?.location}</div> </td>
              </tr>
            ))
          }
        </tbody>
      </table>
    </div>
  );
};

export default DashboardTable;
